import { ScreenProps } from '@components-common/types';
import { Page } from '@components-common/layouts';

export const defaultScreen: Omit<ScreenProps, 'id'> & { id?: string } = {
  cat: 'screen',
  type: 'custom',
  route: {
    to: '/errors/not-found',
    roles: [],
    protected: true,
  } as any,

  view: {
    key: 'page',
    Component: Page,
    props: {
      breadcrumbs: true,
      title: 'NOT_SET',
    },
    children: [],
  } as any,
  components: {} as any,
};
